import { faMapLocationDot, faVideo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import copy from "../../template/images/copy.svg";
import qr from "../../template/images/qr.svg";
import { downloadQr } from "../../util/axiosConfig/api/api";
import { ENV } from "./../../util/Env";
import { decryptWithSpaces } from './../../util/DecryptWithSpaces';

const Eventscard = (props) => {
  const { storeData, page } = props;
  const [decryptedTrainerName, setDecryptedTrainerName] = useState("");
  useEffect(() => {
    let mounted = true;
    const decryptName = async () => {
      if (!storeData || !storeData.trainerName) {
        if (mounted) setDecryptedTrainerName("");
        return;
      }
      try {
        const dec = await decryptWithSpaces(storeData.trainerName);
        if (mounted) setDecryptedTrainerName(dec || storeData.trainerName || "");
      } catch (e) {
        if (mounted) setDecryptedTrainerName(storeData.trainerName || "");
      }
    };
    decryptName();
    return () => { mounted = false; };
  }, [storeData && storeData.trainerName]);
  const newDate = new Date();
  const navigate = useNavigate();
  const handleRegisterType = (tabName) => navigate(`/Registration/${tabName}`);

  const handleQrDownload = (id, ename, date, time) => {
    const resp = downloadQr(parseInt(id), "qr", ename, date, time);
    resp.then(
      (success) => {
        const htmlContent = document.createElement("div");
        htmlContent.innerHTML =
          "QR Downloaded Successfully " +
          `<img src=${success} style="width: auto; height: 200px; display: block; text-align: center; margin: auto;"/>`;
        const a = document.createElement("a");
        a.href = success;
        a.download = `qr_${ename}_${date}_${time}_.png`;
        a.click();
        swal({
          content: htmlContent,
          html: true,
          icon: "success",
          backdrop: false,
          allowOutsideClick: false,
          closeOnClickOutside: false,
          showCancelButton: true,
          focusConfirm: true,
        });
      },
      () => {}
    );
  };

  const handleCopyLink = (id) => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = `<p style=" text-align: center; margin-top: 45px; ">  Event registration link copied successfully </p>`;
    swal({
      content: htmlContent,
      html: true,
      icon: "success",
      backdrop: false,
      allowOutsideClick: false,
      closeOnClickOutside: false,
      showCancelButton: true,
      focusConfirm: true,
    });
    navigator.clipboard.writeText(`${ENV.URL_APP}/Registration/${id}`);
  };

  const isOffline = !!storeData.offline;
  const formatDate = (t) => moment(t).format("DD-MM-YYYY");
  const formatTime = (t) => moment(t).format("h:mm A");

  const renderTypeBadge = (small) => {
    if (isOffline) {
      return (
        <>
          <FontAwesomeIcon icon={faMapLocationDot} className={small ? " Register_icon_offline pe-2" : " Register_icon_offline px-1"} />
          <span>{small ? "Offline" : "Offline"}</span>
        </>
      );
    }
    return (
      <>
        <FontAwesomeIcon icon={faVideo} className={small ? " Register_icon_online pe-2" : " Register_icon_online px-1"} />
        <span>{small ? "Online" : "Online"}</span>
      </>
    );
  };

  const renderDetailsRows = () => (
    <table>
      <tbody>
        <tr className="usp_Trainer">
          <td>Trainer </td>
          <td>
            <span className="mx-2">:</span>
            <span className="text_span">{decryptedTrainerName ? decryptedTrainerName : (storeData.trainerName ? storeData.trainerName : "")}</span>
          </td>
        </tr>
        <tr className="usp_Trainer">
          <td>Language </td>
          <td>
            <span className="mx-2">:</span>
            <span className="text_span">{storeData.language ? storeData.language : ""}</span>
          </td>
        </tr>
        <tr className="usp_Trainer">
          <td>Date </td>
          <td>
            <span className="mx-2">:</span>
            <span className="text_span">{formatDate(storeData.startTime)}</span>
          </td>
        </tr>
        <tr className="usp_Trainer">
          <td>Time </td>
          <td>
            <span className="mx-2">:</span>
            <span className="text_span">{formatTime(storeData.startTime)}</span>
          </td>
        </tr>
        {isOffline && (
          <>
            <tr className="usp_Trainer">
              <td>Place </td>
              <td>
                <span className="mx-2">:</span>
                <span className="text_span">{storeData.place ? storeData.place : ""}</span>
              </td>
            </tr>
            <tr className="usp_Trainer">
              <td>City </td>
              <td>
                <span className="mx-2">:</span>
                <span className="text_span">{storeData.city ? storeData.city : ""}</span>
              </td>
            </tr>
            <tr className="usp_Trainer">
              <td>Pincode </td>
              <td>
                <span className="mx-2">:</span>
                <span className="text_span">{storeData.pincode ? storeData.pincode : ""}</span>
              </td>
            </tr>
          </>
        )}
      </tbody>
    </table>
  );

  const renderFooter = () => {
    const isRegPage = page === "reg";
    const isPastPage = page === "past";
    const isCancelledOrCompleted = storeData.status === "Cancelled" || storeData.status === "Completed";
    const isRegistrationClosed = storeData.maxParticipants <= storeData.regCount || !storeData.activeForRegistration || storeData.openForEveryone === false;

    if (isRegPage) {
      return (
        <div className="card-footer ps-3 pe-0 py-0 usp_footer">
          <div className="row justify-content-between align-items-center">
            <div className="col-6 ">{renderTypeBadge(true)}</div>
            <div className="col-6  Register_btn_div_reg">
              <div className={isOffline ? "Register_button_reg Register_button_offline" : "Register_button_reg Register_button_online"}>
                {isOffline ? <FontAwesomeIcon icon={faMapLocationDot} /> : <FontAwesomeIcon icon={faVideo} />}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (isPastPage) return <></>;

    if (isCancelledOrCompleted) {
      return (
        <div className="card-footer ps-3 pe-0 py-0 usp_footer">
          <div className="row justify-content-between align-items-center">
            <span className={storeData.status === "Completed" ? "stamp is-approved" : "stamp is-nope"}>
              {storeData.status === "Completed" ? "Completed" : storeData.status}
            </span>
          </div>
        </div>
      );
    }

    if (isRegistrationClosed) {
      return (
        <div className="card-footer ps-3 pe-0 py-0 usp_footer">
          <div className="row justify-content-between align-items-center">
            <span className="stamp is-nope">Registration Closed</span>
          </div>
        </div>
      );
    }

    return (
      <div className="card-footer ps-3 pe-0 py-0 usp_footer">
        <div className="row justify-content-between align-items-center">
          <div className="col-6 ">
            <button type="button" className="btn" onClick={() => handleCopyLink(storeData.id)}>
              <img src={copy} /> 
            </button>
            <button type="button" className="btn" onClick={() => handleQrDownload(storeData.id, storeData.name, formatDate(storeData.startTime), formatTime(storeData.startTime))}>
              <img src={qr} />
            </button>
          </div>

          <div className="col-6  Register_btn_div">
            <button
              type="button"
              disabled={storeData.openForEveryone ? false : "disabled"}
              className={isOffline ? "Register_button Register_button_offline" : "Register_button Register_button_online"}
              onClick={() => handleRegisterType(storeData.id)}
            >
              Register
            </button> 
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={
          page == "reg"
            ? "col-xl-8 col-lg-7 col-md-8 col-sm-12 col-12"
            : "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
        }
      >
        <div
          className={
            page == "reg"
              ? !storeData.offline
                ? "reg_card_online card  usp_card reg_card"
                : "reg_card_offline card  usp_card reg_card"
              : "card  usp_card"
          }
        >
          <div
            className={page == "past" ? "card-body disable-card" : "card-body"}
          >
            {/* {page == "reg"?<div className="regleft_Con"><div className="sub_regleft_Con"><img src={onlineCR}/></div></div>:""} */}
            {page == "reg" ? (
              <></>
            ) : (
              <>
                {!storeData.offline ? (
                  <>
                    <FontAwesomeIcon
                      icon={faVideo}
                      className=" Register_icon_online pe-2"
                    />
                    Online
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faMapLocationDot}
                      className=" Register_icon_offline pe-2"
                    />
                    Offline
                  </>
                )}
              </>
            )}
            <h5 className="usp_title">
              {storeData.eventTopicName ? storeData.eventTopicName : ""}
            </h5>
            <p className="usp_Trainer">
              {" "}
              <span className="inside-trainer">{storeData.cardTitle ? storeData.cardTitle : "Mutual Fund"}</span>{" "}
            </p>
            {renderDetailsRows()}

            {/* <p className="usp_Trainer">Trainer : <span>{storeData.trainerName ? storeData.trainerName : ""}</span> </p>
                        {!storeData.offline ? " " : <p className="usp_TYPE"> In <span className={!storeData.offline  ? " Register_icon_online usp_TYPE" : " Register_icon_offline usp_TYPE"}> {storeData.city ? storeData.city : ""} ( {storeData.pincode ? storeData.pincode : ""})</span>   </p>}

                        <p className="usp_TYPE">At  <span> {moment(storeData.startTime).format('DD-MM-YYYY')}</span> <span> @  {moment(storeData.startTime).format('h:mm A')}</span></p> */}
          </div>

          {renderFooter()}
        </div>
      </div>
    </>
  );
};

export default Eventscard;
